<script>
export default {
  props: {
    item: {
      type: Object
    },
    content: {
      type: Object
    }
  }
}
</script>
<template>
  <v-expansion-panel id="upload_validation_details_mail_specs">
    <v-expansion-panel-header>
      {{ $t('component.documentValidation.documentDetailsParcel.parcel') }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-list class="pt-0 pb-0">
        <v-list-item>
          <v-list-item-content>
            {{ $t('component.documentValidation.documentDetailsParcel.pages') }}:
            {{ item.pageCount }}
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            {{ $t('component.documentValidation.documentDetailsParcel.parcel.number') }}:
            {{ item.documentId }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
.v-list-item {
  min-height: 28px;
}
.v-list-item__content {
  padding: 0 !important;
}
</style>
